<template>
	<b-modal
		:visible="show"
		@hide="() => this.$emit('close')"
		hide-footer
		:title="'Discount' | translate"
	>
		<form action="." method="post" class="text-center">
			<fieldset class="form-group">
				<label
					>{{ 'Master Franchise' | translate }} /
					{{ 'Franchise' | translate }}</label
				>
				<v-select
					:on-change="changeFranchise"
					:options="franchiseList"
				></v-select>
				<label>{{ 'Start' | translate }}</label>
				<datepicker v-model="start" :format="format"></datepicker>
				<label>{{ 'End' | translate }}</label>
				<datepicker v-model="end" :format="format"></datepicker>
				<label>{{ 'Discount' | translate }}</label>
				<input type="number" class="form-control" v-model="value" />
			</fieldset>
			<button class="btn btn-primary" @click.prevent="sendDiscount">
				{{ 'Send' | translate }}
			</button>
		</form>
	</b-modal>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'
export default {
	name: 'dashboard-modal-discount',
	props: ['show'],
	data() {
		return {
			franchiseList: [],
			format: 'dd/MM/yyyy',
			start: null,
			end: null,
			value: 1,
			userId: 0,
		}
	},
	components: {
		Datepicker,
		vSelect,
	},
	beforeMount() {
		this.axios({
			method: 'get',
			url: 'users?role=master franchise',
		}).then(response => {
			let masterArray = response.data
			for (var i = 0; i < masterArray.length; i++) {
				let master = {
					value: masterArray[i].id,
					label:
						masterArray[i].last_name +
						' ' +
						masterArray[i].first_name +
						' ' +
						masterArray[i].middle_name,
				}
				this.franchiseList.push(master)
			}
			this.axios({
				method: 'get',
				url: 'users?role=franchise',
			}).then(response => {
				let franchiseArray = response.data
				for (var i = 0; i < franchiseArray.length; i++) {
					let franchise = {
						value: franchiseArray[i].id,
						label:
							franchiseArray[i].last_name +
							' ' +
							franchiseArray[i].first_name +
							' ' +
							franchiseArray[i].middle_name,
					}
					this.franchiseList.push(franchise)
				}
			})
		})
	},
	methods: {
		changeFranchise(val) {
			this.userId = val.value
		},
		sendDiscount() {
			let start = this.start.toISOString().slice(0, 10)
			let end = this.end.toISOString().slice(0, 10)
			this.axios({
				method: 'post',
				url: `users/user/${
					this.userId
				}/assign_discount?start=${start}&end=${end}&value=${Number(
					this.value
				)}`,
			}).then(response => {
				this.$emit('close')
			})
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button.btn.btn-primary {
	margin: 0;
}
</style>
